<div *ngIf="displayPrintButton === true || displayDownloadButton === true" style="display: flex; justify-content: flex-end;">
    <app-button iconName="download"
                fill="solid" size="small"
                (clickEvent)="download()"
                *ngIf="displayDownloadButton === true"></app-button>
    <app-button iconName="printer"
                fill="solid" size="small"
                (clickEvent)="print()"
                *ngIf="displayPrintButton"></app-button>
</div>

<pdf-viewer [src]="pdfSrc" *ngIf="pdfSrc"
            [render-text]="true"
            [original-size]="true"
            [fit-to-page]="true"
            style="width: 100%; height: 500px"
></pdf-viewer>
